import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=89df7bae&scoped=true"
import script from "./metadata.vue?vue&type=script&lang=js"
export * from "./metadata.vue?vue&type=script&lang=js"
import style0 from "./metadata.vue?vue&type=style&index=0&id=89df7bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89df7bae",
  null
  
)

export default component.exports